 //const BaseUrl = "http://localhost:8081";
//const BaseUrl = "https://seeds.hkcl.net";
const BaseUrl = "https://haryanaseedsb.hkcl.net";


export default BaseUrl;